export default __webpack_public_path__ + "static/media/calendar-outline1.90eeab6a.svg";